// ============================================
// STATIC DATA - DAYS, FORM FIELDS, DENTIST FIELDS
// ============================================

export const getAllDays = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const formFields = [
  {
    name: "clinicName",
    type: "text",
    placeholder: "Clinic Name",
    label: "Clinic Name",
  },
  {
    name: "location",
    type: "text",
    placeholder: "Address",
    label: "Address",
  },
  {
    name: "startTime",
    type: "time",
    placeholder: "Start Time",
    label: "Start Time",
  },
  {
    name: "endTime",
    type: "time",
    placeholder: "End Time",
    label: "End Time",
  },
  {
    name: "incharge",
    type: "text",
    placeholder: "Incharge Name",
    label: "Incharge",
  },
  {
    name: "clinicContact",
    type: "text", // Changed to text to avoid leading zero issues
    placeholder: "Mobile Number",
    label: "Mobile Number",
  },
  {
    name: "clinicNewFees",
    type: "number",
    placeholder: "₹",
    label: "Clinic New Patient Fee",
  },
  {
    name: "clinicOldFees",
    type: "number",
    placeholder: "₹",
    label: "Clinic Old Patient Fee",
  },
];

export const dentistFields = [
  {
    name: "generalDentistry",
    type: "number",
    placeholder: "General Dentistry",
    label: "General Dentistry",
  },
  {
    name: "fractureAndTrauma",
    type: "number",
    placeholder: "Fracture & Trauma",
    label: "Fracture & Trauma",
  },
  {
    name: "childDentistry",
    type: "number",
    placeholder: "Child Dentistry",
    label: "Child Dentistry",
  },
  {
    name: "cosmeticDentistry",
    type: "number",
    placeholder: "Cosmetic Dentistry",
    label: "Cosmetic Dentistry",
  },
  {
    name: "vaneersAndLaminates",
    type: "number",
    placeholder: "Vaneers & Laminates",
    label: "Vaneers & Laminates",
  },
  {
    name: "implant",
    type: "number",
    placeholder: "Implant",
    label: "Implant",
  },
  {
    name: "dentalCheckUp",
    type: "number",
    placeholder: "Dental Check Up",
    label: "Dental Check Up",
  },
  {
    name: "extraction",
    type: "number",
    placeholder: "Extraction",
    label: "Extraction",
  },
  {
    name: "scalingAndTeethCleaning",
    type: "number",
    placeholder: "Scaling & Teeth Cleaning",
    label: "Scaling & Teeth Cleaning",
  },
  {
    name: "restorationAndFilling",
    type: "number",
    placeholder: "Restoration & Filling",
    label: "Restoration & Filling",
  },
  {
    name: "oralAndMaxillofacialSurgery",
    type: "number",
    placeholder: "Oral & Maxillofacial Surgery",
    label: "Oral & Maxillofacial Surgery",
  },
  {
    name: "rootCanalTreatment",
    type: "number",
    placeholder: "Root Canal Treatment",
    label: "Root Canal Treatment",
  },
  {
    name: "crownsAndBridges",
    type: "number",
    placeholder: "Crowns & Bridges",
    label: "Crowns & Bridges",
  },
  {
    name: "orthodonticsTreatment",
    type: "number",
    placeholder: "Orthodontics Treatment",
    label: "Orthodontics Treatment",
  },
];